import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
import commons from './modules/commons'
import authentication from './modules/authentication'
import products from './modules/products'
import orders from './modules/orders'
import categories from './modules/categories'
import order_products from './modules/order_products'
import users from './modules/users'
import pages from './modules/pages'
import receipts from './modules/receipts'
import returns from './modules/returns'
import recharges from './modules/recharges'
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authentication,
    commons,
    products,
    orders,
    categories,
    order_products,
    users,
    pages,
    receipts,
    recharges,
    returns
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({paths:['authentication', 'commons', 'roles'], storage: window.localStorage})]
});
